<template>
  <div>
    <h2>我报名的活动</h2>
    <a-divider></a-divider>
    <div class="pannel">
      <a-button type="danger" @click="toOrder()" icon="right-circle">查看我的订单</a-button>

      <a-button @click="searchUsernameVisible=true" type="primary" style="float:right;">查询账号</a-button>
      <a-list :dataSource="dataSource" :pagination="pagination" :locale="{emptyText: '暂无报名的活动'}">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card class="item-card" >
            <a-row :gutter="24">
              <a-col :sm="8" :xs="24">
                <div class="img-zoom">
                  <img class="cover" :src="item.eventCover_url" alt="" />
                </div>
              </a-col>
              <a-col :sm="12" :xs="24">
                <h2>{{item.eventName}} 
                <a-tag>{{item.eventType_dictText}}</a-tag>
                <a-tag color="red" v-if="item.applyStatus==0">未支付</a-tag>
                <a-tag color="red" v-if="item.applyStatus==-1">已退费</a-tag>
                </h2>
                <p>
                  <span v-if="item.myEventCategoryPid_dictText">赛项：{{item.myEventCategoryPid_dictText}} </span>
                  <span v-if="item.myEventCategory_dictText">组别：{{item.myEventCategory_dictText}}</span>
                </p>
                <p>报名起止时间：{{item.eventBegin}} ~ {{item.eventEnd}}</p>
                <p v-if="item.examBegin">正式考试时间：{{item.examBegin}}</p>
              </a-col>
              <a-col v-if="item.applyStatus >= 0" :sm="4" :xs="24" class="event-opts">
                <!-- <a-button type="dashed" @click="toEventDetail(item)">活动详情</a-button> -->
                <a-button @click="showApplyEvent(item)">报名信息</a-button>
                <a-button v-if="item.ticketUrl" type="dashed" @click="download(item.ticketUrl)">准考证</a-button>
                <a-button v-if="item.applyStatus==1 && item.takePartType==1" type="primary" @click="showSubmitWork(item)">{{item.worksVOS.length>0?'查看作品':'作品提交'}}</a-button>
                <a-button v-if="item.applyStatus==1 && item.takePartType==0 && item.examStatus > 0" :type="item.examStatus==2?'danger':'primary'" :disabled="item.examStatus==3" @click="toPaper(item)">{{item.examStatus==1?'测评模拟':'去测评'}}</a-button>
                <a-button v-if="item.canQueryScore" @click="toScore(item.eventApplyId)">测评成绩</a-button>
                <a-button v-if="canQueryCert(item)" @click="toCert(item.certId)">测评证书</a-button>
                <a-button v-if="item.applyStatus==0" @click="toPay(item)" type="danger">支付</a-button>
              </a-col>
            </a-row>
          </a-card>
        </a-list-item>
      </a-list>
    </div>
    <EventPay ref="eventPay" @payOk="payOk"/>
    <EventApplyModal ref="applyModal"/>
    <SubmitWorkModal ref="submitModal" @ok="submitOk"/>
    <a-modal title="查询账号" 
      :width="400" 
      :visible="searchUsernameVisible" 
      :maskClosable="false" 
      @ok="searchUsername"
      okText="查询"
      @cancel="searchUsernameVisible = false">
        <p>请输入身份证号查询已经报名的账号。</p>
        <a-input placeholder="请输入身份证号" v-model="searchIdcard"></a-input>
        <a-divider></a-divider>
        <div v-if="searchResult">
          <p>
            查询结果：
          </p>
          <p>{{searchResult}}</p>
        </div>
        
    </a-modal>
  </div>
</template>

<script>

import "@/assets/less/animation.css";
import { getAction, postAction } from "@/api/manage";
import EventApplyModal from "../modal/EventApplyModal"
import SubmitWorkModal from "../modal/SubmitWorkModal"
import EventPay from "../modal/EventPay"
import {filterMultiDictText} from '@/components/jeecg/JDictSelectUtil'
import { loadCategoryData } from '@/api/api'
export default {
  name: "Event",
  components:{
    EventApplyModal,
    SubmitWorkModal,
    EventPay
  },
  data() {
    return {
      dataSource: [],
      dictOptions: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 6,
      },
      searchUsernameVisible: false,
      searchIdcard: '',
      searchResult: ''
    };
  },
  created() {
    // loadCategoryData({code:"A05"}).then((res) => {
    //   if (res.success) {
    //     this.$set(this.dictOptions, 'eventCategory', res.result)
    //   }
    // })
    this.getMyApplyEvent()
  },
  methods:{
    searchUsername(){
      if(this.searchIdcard == ''){
        this.$message.info('请输入身份证号码')
        return
      }
      getAction("/aice/searchUsername?idcard="+this.searchIdcard).then(res=>{
        if(res.success){
          this.searchResult = res.message
        }
      })
    },
    // getDictValue(text){
    //   return filterMultiDictText(this.dictOptions['eventCategory'], text)
    // },
    getMyApplyEvent(){
      getAction("/teaching/teachingEventApply/myApply").then((res) => {
        if (res.success) {
          this.dataSource = res.result;
        }
      });
    },
    toEventDetail(item){
      let route = this.$router.resolve({
        path: "/event/detail",
        query: {
          id: item.eventId,
        },
      });
      window.open(route.href, '_blank');
    },
    download(url){
      window.open(url + "?t="+new Date().getTime())
    },
    toOrder(){
      this.$router.push({path: '/user/order'})
    },
    toPay(applyInfo){
        console.log(applyInfo);
        getAction("/teaching/teachingOrder/getUnPayOrderInfoByEventApply?eventApplyId="+applyInfo.eventApplyId).then(res=>{
          if(res.success){
            this.$refs.eventPay.open(res.result)
          }else{
            this.$message.error(res.message)
          }
        })
    },
    payOk(){
      this.getMyApplyEvent()
    },
    submitOk(){
      this.getMyApplyEvent()
    },
    showApplyEvent(applyInfo){
      this.$refs.applyModal.open(applyInfo.eventId, applyInfo.myEventCategory)
    },
    showSubmitWork(info){
      if(info.takePartType == 2){
        this.$success({
          title: "提示",
          content: (
            <div>
              <p>线下活动报名成功后直接提示凭证件前往！</p>
            </div>
          ),
        });
      }else{
        this.$refs.submitModal.open(info)
      }
    },
    toPaper(item){
      console.log(item);
      let route = this.$router.resolve({
        path: "/examine",
        query: {
          eaid: item.eventApplyId,
          category: item.myEventCategory_dictText
        },
      });
      window.open(route.href, '_blank');
    },
    toScore(eventApplyId){
      window.open("/cert/score.html?id="+eventApplyId)
    },
    canQueryCert(item){
      let now = new Date().getTime()
      let startTime = item.queryScoreBegin?new Date(item.queryScoreBegin).getTime():0
      let endTime = item.queryCertEnd?new Date(item.queryCertEnd).getTime():0
      if(item.certId && item.certId!='-1' && item.queryScoreBegin && startTime < now && endTime > now ){
        return true
      }else{
        return false
      }
    },
    toCert(certId){
      window.open("/cert/query.html?id="+certId)
    },
  }
};
</script>

<style lang="less" scoped>
.pannel{
  .item-card{
    .cover{
      width: 100%;
    }
    .event-opts{
      .ant-btn{
        margin: 8px 0;
      }
      
    }
  }

}
</style>